import {
  isRouteErrorResponse,
  useRouteError,
  useNavigate,
} from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function RootErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = 'Something went wrong';
  let description = 'An unexpected error occurred while loading this page.';

  if (isRouteErrorResponse(error)) {
    title = `Error ${error.status}`;
    description = error.statusText || description;
  } else if (error instanceof Error) {
    description = error.message;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-8 text-center bg-bg-primary">
      <div>
        <h1 className="text-3xl font-semibold text-text-primary">{title}</h1>
        <p className="mt-2 text-text-secondary">{description}</p>
      </div>
      <Button
        variant="pravos-primary"
        onClick={() => navigate('/')}
      >
        Go back home
      </Button>
    </div>
  );
}
